import SuspenseLoading from '@/components/common/SuspenseLoading';
import { Layout, Typography, theme } from 'antd';
import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BigfootLogo from '../../assets/bigfoot_logo.svg';
import './AuthLayout.less';

const { Content } = Layout;
const { Text } = Typography;

const AuthLayout = () => {
  const location = useLocation();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout className="auth-page">
      <Content className="auth-container">
        <Suspense fallback={<SuspenseLoading />} key={location.pathname}>
          <div className="brand-logo">
            <img src={BigfootLogo} alt="Bigfoot Logo" />
          </div>

          <div className="login-form" style={{ background: colorBgContainer }}>
            <Outlet />
          </div>

          <div className="copyright-notice">
            <Text>©2026 Sparebox Technologies</Text>
          </div>
        </Suspense>
      </Content>
      {/* <div className='background-image'></div> */}
    </Layout>
  );
};

export default AuthLayout;
